<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2e43fd/tc-custom/9781460315361.jpg?1726574237594" alt="This image is the cover for the book His Brand of Passion, The Bryants: Powerful & Proud"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Brand of Passion, The Bryants: Powerful & Proud
      </h1>
      <p class="bookDescription body article font2">
        <i>Money usually solves everything</i><br/><br/>Billionaire Aaron Bryant lives and works on a knife's edge; his dark, brooding persona and fearsome reputation hide a shameful family secret. So sassy maid of honor Zoe Parker is an unwelcome distraction when, at his brother's wedding, she hides Aaron's ever-ringing phone down her tight pink dress!<br/><br/><i>But Aaron's never had a problem like this before!</i><br/><br/>Aaron's arrogant, skilled retrieval of his property sparks a chemistry that ends in a mind-blowing one-night stand. But such uncontrollable passion leaves an indelible mark on their lives. He never expected to see Zoe again, until two little lines appeared on a stick.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Hewitt
      </h2>
      
      <p class="authorDescription body article">Kate Hewitt has worked a variety of different jobs, from drama teacher to editorial assistant to youth worker, but writing romance is the best one yet. She also writes women&#39;s fiction and all her stories celebrate the healing and redemptive power of love. Kate lives in a tiny village in the English Cotswolds with her husband, five children, and an overly affectionate Golden Retriever.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f99ea766